import request from "../utils/request";
export async function setKuverSetting(kuver){
  return request.post("Kuver",kuver);
}
export async function getKuverSetting(){
  return request.get("Kuver");
}
